export default "__VITE_ASSET__y8dG8h8j__"